/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox, FormControlLabel, makeStyles,
} from '@material-ui/core';
import { Loading } from '../../../../helpers/utils';

const useStyles = makeStyles({
  skill: {
    marginTop: '10px',
  },
});

const ContentCheckbox = ({
  item, allChecked, contentIds, setContentIds,
}) => {
  const [checked, setChecked] = useState(false);
  const [label, setLabel] = useState(item.description);
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const handleContentsArr = (newCheckedState) => {
    const contentsArr = [...contentIds];
    if (!contentsArr.includes(item.skillId) && newCheckedState === true) {
      contentsArr.push(item.skillId);
    } else if (contentsArr.includes(item.skillId) && newCheckedState === false) {
      contentsArr.forEach((id, index) => {
        if (id === item.skillId) {
          contentsArr.splice(index, 1);
        }
      });
    }
    setContentIds(contentsArr);
  };

  useEffect(() => {
    setChecked(allChecked);
  }, [allChecked]);

  useEffect(() => {
    if (contentIds.includes(item.skillId)) {
      setChecked(true);
    }
  }, [contentIds]);

  const handleChange = () => {
    const newCheckedState = !checked;
    setChecked(newCheckedState);
    handleContentsArr(newCheckedState);
  };

  useEffect(() => {
    if (item.categories) {
      let categories = label;
      item.categories.forEach((elem, index) => {
        if (index === item.categories.length - 1) {
          categories += ` ${elem}.`;
        } else {
          categories += ` ${elem},`;
        }
      });
      setLabel(categories);
    }
  }, []);

  if (loading) {
    return (
      <Loading />
    );
  }
  return (
    <FormControlLabel
      value={item.skillId}
      checked={checked}
      control={<Checkbox color="primary" />}
      label={label}
      onChange={handleChange}
      className={classes.skill}
    />
  );
};

ContentCheckbox.propTypes = {
  item: PropTypes.object.isRequired,
  contentIds: PropTypes.array.isRequired,
  allChecked: PropTypes.bool.isRequired,
  setContentIds: PropTypes.func.isRequired,
};

export default ContentCheckbox;
